// ABOUTME: React Router configuration for Oleum BI frontend (Goldman POC).
// ABOUTME: Defines routes for home, investigations, data sources, and admin pages.

import { createBrowserRouter, Navigate } from 'react-router-dom';
import { RootLayout } from '@/components/layout/RootLayout';
import { HomePage } from '@/pages/HomePage';
import { InvestigationsPage } from '@/pages/InvestigationsPage';
import { InvestigationDetailPage } from '@/pages/InvestigationDetailPage';
import { OnboardingPage } from '@/pages/OnboardingPage';
import { AdminDashboard } from '@/pages/admin/Dashboard';
import { WorkspaceList } from '@/pages/admin/WorkspaceList';
import { WorkspaceDetail } from '@/pages/admin/WorkspaceDetail';
import { AgentConfigPage, UsageAnalyticsPage } from '@/pages/admin/index';
import { NotFoundPage } from '@/pages/NotFoundPage';
import { LoginPage } from '@/pages/LoginPage';
import { CallbackPage } from '@/pages/auth/CallbackPage';
import { VerifyEmailPage } from '@/pages/auth/VerifyEmailPage';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { AdminRoute } from '@/components/auth/AdminRoute';
import { DataSourcesPage } from '@/pages/DataSourcesPage';

export const router = createBrowserRouter([
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/auth/callback',
    element: <CallbackPage />,
  },
  {
    path: '/verify-email',
    element: <VerifyEmailPage />,
  },
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <HomePage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'investigations',
        element: (
          <ProtectedRoute>
            <InvestigationsPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'investigations/:id',
        element: (
          <ProtectedRoute>
            <InvestigationDetailPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'onboarding',
        element: (
          <ProtectedRoute>
            <OnboardingPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'data-sources',
        element: (
          <ProtectedRoute>
            <DataSourcesPage />
          </ProtectedRoute>
        ),
      },
      {
        path: 'admin',
        element: (
          <AdminRoute>
            <AdminDashboard />
          </AdminRoute>
        ),
      },
      {
        path: 'admin/workspaces',
        element: (
          <AdminRoute>
            <WorkspaceList />
          </AdminRoute>
        ),
      },
      {
        path: 'admin/workspaces/:workspaceId',
        element: (
          <AdminRoute>
            <WorkspaceDetail />
          </AdminRoute>
        ),
      },
      {
        path: 'admin/workspaces/:workspaceId/config',
        element: (
          <AdminRoute>
            <AgentConfigPage />
          </AdminRoute>
        ),
      },
      {
        path: 'admin/workspaces/:workspaceId/usage',
        element: (
          <AdminRoute>
            <UsageAnalyticsPage />
          </AdminRoute>
        ),
      },
      {
        path: '404',
        element: <NotFoundPage />,
      },
      {
        path: '*',
        element: <Navigate to="/404" replace />,
      },
    ],
  },
]);
